import React from 'react'
import landscape_banner from "../Components/Assets/poloBanner.jpg"
import potrait_banner from "../Components/Assets/poloBanner_Mobile.jpg"
import { Link } from 'react-router-dom'
import Hero from '../Components/Hero/Hero'

const Polo = () => {
  return (
    <div>
        <Hero landscape_image = {landscape_banner} potrait_image = {potrait_banner}/>
        <div className="productContent">
            {/*Redirect button*/}
            <div className="button_container">
                <button>Get your own custom Basketball jerseys!</button>
            </div>

            {/*On-Court*/}
            <div className="content_heading">
                <span>CASUAL</span>
            </div>
            <hr />
            <div className="content_tagline">
                <div className="bar"></div>
                <span>Add your brand, club or company logos</span>
            </div>
            <div className="content_text">
                <ul>
                    <li><span>Screen Printed, Direct to Garment, Cut, Color, etc</span></li>
                    <li><span>Sampling prior to production</span></li>
                    <li><span>Quick Turnaround time</span></li>
                    <li><span>No Minimum Order Quanity</span></li>
                    <li><span>Unlimited options with design process</span></li>
                </ul>
            </div>
            <div className="content_sub_heading">
                <span>Good For</span>
            </div>
            <div className="content_text">
                <ul>
                    <li><span>Brands</span></li>
                    <li><span>Uniforms</span></li>
                    <li><span>Corporate</span></li>
                    <li><span>Anything else</span></li>
                </ul>
            </div>
            <div className="redirect_button">
                <span>Your logos, your choice!</span>
                <Link to="/contact"><button>Get in Touch</button></Link>
            </div>

            <div className="content_heading">
                <span>SPORTS</span>
            </div>
            <hr />
            <div className="content_tagline">
                <div className="bar"></div>
                <span>Make your club stand out!</span>
            </div>
            <div className="content_text">
                <ul>
                    <li><span>Printed or sublimated options</span></li>
                    <li><span>Sampling prior to production</span></li>
                    <li><span>Quick Turnaround time</span></li>
                    <li><span>No Minimum Order Quanity</span></li>
                    <li><span>Unlimited options with design process</span></li>
                </ul>
            </div>
            <div className="content_sub_heading">
                <span>Good For</span>
            </div>
            <div className="content_text">
                <ul>
                    <li><span>Sports Clubs</span></li>
                    <li><span>Anything else</span></li>
                </ul>
            </div>
            <div className="redirect_button">
                <span>Unlimited design with sublimation!</span>
                <Link to="/contact"><button>Get in Touch</button></Link>
            </div>

            <div className="content_heading">
                <span>WOMEN'S</span>
            </div>
            <hr />
            <div className="content_tagline">
                <div className="bar"></div>
                <span>Add your brand, club or company logos</span>
            </div>
            <div className="content_text">
                <ul>
                    <li><span>Printed or sublimated options</span></li>
                    <li><span>Sampling prior to production</span></li>
                    <li><span>Quick Turnaround time</span></li>
                    <li><span>No Minimum Order Quanity</span></li>
                    <li><span>Unlimited options with design process</span></li>
                </ul>
            </div>
            <div className="content_sub_heading">
                <span>Good For</span>
            </div>
            <div className="content_text">
                <ul>
                    <li><span>Brands</span></li>
                    <li><span>Sports Clubs</span></li>
                    <li><span>Uniforms</span></li>
                    <li><span>Anything else</span></li>
                </ul>
            </div>
            <div className="redirect_button">
                <span>Fully customised women's polo's!</span>
                <Link to="/contact"><button>Get in Touch</button></Link>
            </div>

            <div className="content_heading">
                <span>LONG SLEEVE</span>
            </div>
            <hr />
            <div className="content_tagline">
                <div className="bar"></div>
                <span>Keep your arms warm!</span>
            </div>
            <div className="content_text">
                <ul>
                    <li><span>Printed or sublimated options</span></li>
                    <li><span>Sampling prior to production</span></li>
                    <li><span>Quick Turnaround time</span></li>
                    <li><span>No Minimum Order Quanity</span></li>
                    <li><span>Unlimited options with design process</span></li>
                </ul>
            </div>
            <div className="content_sub_heading">
                <span>Good For</span>
            </div>
            <div className="content_text">
                <ul>
                    <li><span>Clothing Brands</span></li>
                    <li><span>Uniforms</span></li>
                    <li><span>Sports Clubs</span></li>
                    <li><span>Anything else</span></li>
                </ul>
            </div>
            <div className="redirect_button">
                <span>Polo's for winter!</span>
                <Link to="/contact"><button>Get in Touch</button></Link>
            </div>
        </div>
    </div>
  )
}

export default Polo
